<template>
    <div class="app-body">
     <main class="main">
      <div class="container">
        <br />
        <slot></slot>
        <h1>Contact</h1>
        <iframe id="zsfeedbackFrame" width="890" height="570" name="zsfeedbackFrame" scrolling="no" allowtransparency="false" frameborder="0" border="0" src="https://contact.srisrianna.com/support/fbw?formType=AdvancedWebForm&fbwId=5bc978e5c312153ac6d8ebaadc54c68aafb6719abeecaa48&xnQsjsdp=bbBl2HpRFnbUnLk-a6C1tg$$&mode=showWidget&displayType=iframe"></iframe>
      </div>
     </main>      
    </div>
</template>
<script>
        var zsFeedbackTabPref = {};
        zsFeedbackTabPref.jsStaticUrl = "https://js.zohostatic.com/support/fbw_v7/js";
        zsFeedbackTabPref.cssStaticUrl = "https://css.zohostatic.com/support/fbw_v7/css";

        var feedbackInitJs = document.createElement("script");
        feedbackInitJs.type = "text/javascript";
        feedbackInitJs.src = "https://js.zohostatic.com/support/fbw_v7/js/zsfeedbackinit.js";
        window.jQueryAndEncoderUrl = "https://js.zohostatic.com/support/app/js/jqueryandencoder.ffa5afd5124fbedceea9.js";
        window.loadingGifUrl = "https://img.zohostatic.com/support/app/images/loading.31d5c1ec5180c85504bc.gif";
        document.head.appendChild(feedbackInitJs);
        var iframeCss = document.createElement("link");
        iframeCss.setAttribute("rel", "stylesheet");
        iframeCss.setAttribute("type", "text/css");
        iframeCss.setAttribute("href", "https://css.zohostatic.com/support/app/css/ZSFeedbackIframe.01d736f48061243e5cce.css");
        document.head.appendChild(iframeCss);
        zsFeedbackTabPref.defaultDomain = "https://contact.srisrianna.com";
</script>



// WEBPACK FOOTER //
// src/layouts/contact/contact.vue